import type { IconProps } from '../types/IconProps.ts';
export const SquareActivity: IconProps = {
    name: 'SquareActivity',
    children: [
        `<path d="M7 11.98h1.35q.03 0 .05-.04l1.33-4.9c.01-.05.09-.05.1 0l3.23 9.92c.02.05.09.05.1 0l2.02-4.94q.01-.03.05-.04H17" />`,
        `<rect width="18" height="18" x="3" y="3" rx="2" />`,
    ]
};